import type { LocaleGroupFields } from '@tribeplatform/gql-client/graphql'
import type { QueryLocaleGroupArgs } from '@tribeplatform/gql-client/types'

import { KeyConstructor } from './keyConstructor.js'

const LOCALE_GROUP_KEY = 'localeGroup'
const LOCALE_GROUPS_KEY = 'localeGroups'

export const getLocaleGroupKey = KeyConstructor<
  QueryLocaleGroupArgs,
  LocaleGroupFields
>(LOCALE_GROUP_KEY)

export const getLocaleGroupsKey = KeyConstructor<
  Record<string, never>,
  LocaleGroupFields
>(LOCALE_GROUPS_KEY)
